/**
 * A single headline number with a label. No chart library -- just type on white,
 * matching the poster aesthetic. The value is whatever the caller has already
 * formatted (a count, a percentage, or a neutral "Not yet").
 */
export function StatTile({
  label,
  value,
  hint,
}: {
  label: string;
  value: string;
  hint?: string;
}) {
  return (
    <div className="stat-tile">
      <span className="stat-tile__value">{value}</span>
      <span className="stat-tile__label">{label}</span>
      {hint && <span className="stat-tile__hint">{hint}</span>}
    </div>
  );
}
